var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { apiGetOneCategoryCase } from '@/actions/CategoryActionsTs';
import { usePromiseDoingCallback } from '@/hooks/async/loading/usePromiseDoingCallback';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { SESSION_STORAGE_KEY_CATEGORY_CASE } from '@/utils/constants/storage/sessionStorageKey';
import { useSessionStorage } from '@/utils/libs/react-hookz/useSessionStorage';
/**
 * ご相談いただけるテーマの情報を取得するカスタムフック
 */
export const useCaseListFetchCategory = (options) => {
    const { dispatch, unmountRef } = options;
    // カテゴリーを保存
    const { set: setCaseCategoriesData, value: caseCategoriesData } = useSessionStorage(SESSION_STORAGE_KEY_CATEGORY_CASE, {
        defaultValue: null,
    });
    /**
     * カテゴリー情報取得
     */
    const fetchCaseCategoryBase = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const { payload } = yield wrapDispatch(dispatch, apiGetOneCategoryCase({}, {}));
            // 取得したデータを sessionStorage に保存
            setCaseCategoriesData(payload.support_example_categories);
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }), [dispatch, setCaseCategoriesData]);
    // カテゴリー取得のローディング制御
    const { callbackPromiseEvent: fetchCaseCategory, doing: isLoadingCaseCategories, } = usePromiseDoingCallback({
        promiseEvent: fetchCaseCategoryBase,
        unmountRef,
    });
    return {
        caseCategoriesData: caseCategoriesData !== null && caseCategoriesData !== void 0 ? caseCategoriesData : null,
        fetchCaseCategory,
        hasInitialCategoriesData: caseCategoriesData !== null,
        isLoadingCaseCategories,
    };
};
